import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { PageHeader } from "@ant-design/pro-components";
import { Layout, Breadcrumb, Typography, Spin } from "antd";
import { reportAPI } from "../../../services/actions/reports-v2";

/**
 * Components
 */
import { LayoutTopSide } from "components/NavBar/styles";
import TopBar from "components/NavBar/TopBar";
import DrawerSider from "components/NavBar/DrawerSider";

const { Content } = Layout;
const { Paragraph } = Typography;

export default function EditReport() {
  const navigate = useNavigate();
  const { id } = useParams();
  const isDarkMode = useSelector((state) => state.theme.isDarkMode);
  const [report, setReport] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchReport = async () => {
    try {
      const { status, data } = await reportAPI.getReportById(id);
      if (status === 200 || status === 201) {
        setReport(data);
      } else {
        throw new Error("Failed to fetch report");
      }
    } catch (error) {
      setError("Ocorreu um erro ao buscar o relatório.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchReport();
  }, [id]);

  const routes = [
    {
      breadcrumbName: "Relatórios",
      href: "/relatorios/todos",
    },
    {
      breadcrumbName: "Editar",
    },
  ];

  return (
      <Layout style={{ height: "auto" }}>
        <LayoutTopSide>
          <TopBar />
          <Layout>
            <DrawerSider />
            <Layout style={{ padding: "0 24px 24px", height: "100vh" }}>
              <PageHeader
                  className="site-page-header"
                  style={{ margin: "16px 0 24px 0", background: "var(--cp-surface)" }}
                  title="Gerar relatório"
                  onBack={() => window.history.back()}
                  subTitle="Você pode editar qualquer relatório."
                  breadcrumb={
                    <Breadcrumb>
                      {routes.map((a) =>
                          a.href ? (
                              <Breadcrumb.Item key={a.href}>
                                <a href onClick={() => navigate(a.href)}>
                                  {a.breadcrumbName}
                                </a>
                              </Breadcrumb.Item>
                          ) : (
                              <Breadcrumb.Item key={a.breadcrumbName}>
                                {a.breadcrumbName}
                              </Breadcrumb.Item>
                          )
                      )}
                    </Breadcrumb>
                  }
              />
              <Content
                  className="site-layout-background"
                  style={{
                    padding: 0,
                    margin: 0,
                    minHeight: 280,
                    background: "var(--cp-surface)",
                  }}
              >
                {loading ? (
                    <Spin tip="Carregando relatório..." />
                ) : error ? (
                    <Paragraph>{error}</Paragraph>
                ) : (
                    // O editor carrega o app completo do Metabase (não é um embed), então
                    // ele ignora "#theme=night" e usa a preferência do usuário
                    // ("color-scheme", que vem como "auto" por padrão). Propagando o
                    // color-scheme pelo iframe, o prefers-color-scheme de dentro passa a
                    // acompanhar o tema do CLM.
                    report && (
                        <iframe
                            src={`${process.env.REACT_APP_URL}/metabase/dashboard/${report.id}`}
                            title="Relatório"
                            style={{
                              width: "100%",
                              height: "100%",
                              border: "none",
                              colorScheme: isDarkMode ? "dark" : "light",
                            }}
                        />
                    )
                )}
              </Content>
            </Layout>
          </Layout>
        </LayoutTopSide>
      </Layout>
  );
}
